import React from 'react';

export const MonetizationCardSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={590}
    height={316}
    viewBox="0 0 590 316"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1695_3152)">
      <g className="monetization-card-svg-grid">
        <path
          d="M0 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M40.7637 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M83.6729 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M126.582 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M167.346 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M210.255 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M252.091 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M293.928 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M336.836 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M378.673 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M420.509 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M463.418 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M505.255 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M546.019 0V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M590 0.000183105V351.855"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 43.982L609.309 43.982"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 85.8184L609.309 85.8183"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 127.655L609.309 127.655"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 170.564L609.309 170.564"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 212.4L609.309 212.4"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 254.237L609.309 254.237"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
        <path
          d="M0 296.073L609.309 296.073"
          stroke="#0A0A0A"
          strokeOpacity={0.08}
          strokeWidth={0.695721}
        />
      </g>
      <g
        clipPath="url(#clip1_1695_3152)"
        className="monetization-card-svg-lines"
      >
        <path
          d="M83.6729 307.677V245.755V241.328C83.6729 239.9 84.0101 238.519 84.7343 237.288C90.1346 228.107 115.904 187.837 156.605 180.082C186.373 174.411 205.778 192.39 232.202 207.578C246.613 215.861 263.111 226.642 284.517 224.619C304.079 222.771 321.1 170.595 353.66 162.618C364.179 160.041 372.032 171.755 381.097 176.034C392.002 181.18 404.732 180.49 415.12 174.946C485.247 127.342 505.115 85.7513 505.115 85.7513V307.677C505.115 312.468 501.232 316.352 496.441 316.352H92.3475C87.5566 316.352 83.6729 312.468 83.6729 307.677Z"
          fill="url(#paint0_linear_1695_3152)"
        />
        <path
          d="M83.7587 237.938C83.5698 238.289 83.7017 238.728 84.0534 238.916C84.4051 239.105 84.8433 238.974 85.0323 238.622L84.3955 238.28L83.7587 237.938ZM275.603 224.427L275.485 225.141L275.603 224.427ZM505.477 86.1122L497.849 89.503L504.6 94.4131L505.477 86.1122ZM371.574 170.491L372.088 169.981L371.574 170.491ZM84.3955 238.28C85.0323 238.622 85.0323 238.622 85.0324 238.622C85.0327 238.621 85.0329 238.621 85.0333 238.62C85.0341 238.618 85.0354 238.616 85.0372 238.613C85.0408 238.606 85.0463 238.596 85.0537 238.582C85.0685 238.555 85.0909 238.514 85.121 238.46C85.1811 238.35 85.2716 238.187 85.3921 237.974C85.633 237.548 85.9938 236.92 86.4708 236.12C87.4249 234.521 88.8439 232.233 90.6993 229.485C94.4111 223.99 99.8649 216.664 106.833 209.342C120.79 194.676 140.717 180.13 164.815 180.13V179.407V178.684C140.125 178.684 119.842 193.574 105.786 208.345C98.7483 215.741 93.245 223.133 89.5012 228.676C87.6289 231.448 86.1954 233.76 85.2291 235.38C84.746 236.19 84.3795 236.827 84.1333 237.263C84.0101 237.481 83.9171 237.648 83.8545 237.762C83.8232 237.819 83.7996 237.862 83.7836 237.892C83.7756 237.906 83.7695 237.918 83.7654 237.925C83.7633 237.929 83.7617 237.932 83.7606 237.934C83.76 237.935 83.7596 237.936 83.7593 237.936C83.7589 237.937 83.7587 237.938 84.3955 238.28ZM164.815 179.407V180.13C186.519 180.13 201.642 189.225 217.643 199.453C233.635 209.675 250.483 221.015 275.485 225.141L275.603 224.427L275.721 223.714C251.053 219.644 234.44 208.474 218.422 198.235C202.413 188.002 186.976 178.684 164.815 178.684V179.407ZM275.603 224.427L275.485 225.141C284.508 226.629 292.806 221.469 300.635 213.806C308.473 206.132 316.053 195.731 323.591 186.399C331.177 177.009 338.704 168.726 346.519 165.011C350.4 163.165 354.323 162.463 358.353 163.294C362.39 164.127 366.615 166.517 371.061 171L371.574 170.491L372.088 169.981C367.503 165.36 363.037 162.785 358.645 161.878C354.246 160.971 350.002 161.754 345.898 163.705C337.744 167.581 330.029 176.13 322.466 185.491C314.857 194.91 307.381 205.178 299.623 212.773C291.854 220.377 284.014 225.082 275.721 223.714L275.603 224.427ZM371.574 170.491L371.061 171C380.9 180.918 393.03 182.298 405.833 178.495C418.595 174.704 432.093 165.752 444.877 154.902C470.457 133.192 493.411 103.677 502.227 91.8083L501.647 91.3772L501.067 90.9462C492.264 102.797 469.39 132.202 443.941 153.8C431.211 164.604 417.896 173.403 405.421 177.109C392.986 180.803 381.456 179.426 372.088 169.981L371.574 170.491Z"
          fill="black"
        />
        <circle
          cx={140.781}
          cy={183.341}
          r={5.78309}
          fill="black"
        />
        <circle
          cx={275.961}
          cy={223.823}
          r={5.78309}
          fill="black"
        />
        <circle
          cx={351.141}
          cy={162.376}
          r={5.78309}
          fill="black"
        />
        <g clipPath="url(#clip2_1695_3152)">
          <circle
            cx={505.115}
            cy={66.2316}
            r={13.012}
            fill="black"
          />
          <path
            d="M504.875 59.7372C505.689 59.7433 506.423 59.8997 507.073 60.2099L507.313 60.33C507.862 60.6257 508.325 61.0243 508.7 61.5253C509.06 62.0006 509.32 62.5516 509.482 63.1747C509.568 63.5035 509.344 63.8132 509.028 63.872L508.265 64.0146C507.934 64.0762 507.642 63.8511 507.558 63.5566C507.465 63.2318 507.322 62.9462 507.13 62.6982L507.128 62.6953C506.869 62.3488 506.546 62.0844 506.155 61.9003L506.153 61.8994C505.81 61.733 505.436 61.6365 505.03 61.6113L504.854 61.6044C504.399 61.5989 503.994 61.6768 503.636 61.8329C503.276 61.9898 502.996 62.2057 502.79 62.4785L502.788 62.4794C502.587 62.7403 502.486 63.0414 502.486 63.3896C502.486 63.7356 502.578 63.997 502.747 64.1923L502.896 64.3437C503.053 64.4859 503.233 64.6057 503.439 64.7021L503.881 64.8808C504.026 64.9347 504.168 64.9829 504.309 65.0253H504.31L506.547 65.7138C506.811 65.7917 507.112 65.8987 507.448 66.0341H507.447C507.803 66.175 508.145 66.3733 508.474 66.6269C508.816 66.8854 509.097 67.2295 509.315 67.6533H509.314C509.54 68.085 509.647 68.6193 509.647 69.2451C509.647 69.8743 509.527 70.4411 509.284 70.9423L509.285 70.9433C509.049 71.4411 508.717 71.8604 508.29 72.1992L508.288 72.2001C507.864 72.5302 507.374 72.7799 506.819 72.9492L506.818 72.9482C506.264 73.123 505.673 73.2109 505.045 73.2109C504.187 73.2109 503.407 73.0545 502.708 72.7392H502.707C502.014 72.424 501.438 71.9737 500.982 71.3896L500.981 71.3876C500.607 70.8972 500.342 70.3351 500.185 69.7031C500.102 69.3719 500.334 69.0649 500.65 69.0117L501.406 68.8847C501.715 68.833 501.993 69.031 502.087 69.3056C502.289 69.8947 502.627 70.3632 503.101 70.7177L503.318 70.8642C503.838 71.1826 504.436 71.3436 505.118 71.3437C505.625 71.3437 506.076 71.2598 506.474 71.0966L506.62 71.0302C506.952 70.868 507.216 70.6546 507.415 70.3915C507.637 70.0972 507.751 69.747 507.751 69.332C507.751 69.0738 507.708 68.8647 507.631 68.6992L507.628 68.6933C507.552 68.5152 507.446 68.3683 507.311 68.249L507.305 68.2441L507.44 68.1015L507.305 68.2431C507.167 68.1117 507.009 68.0006 506.829 67.9101C506.643 67.8164 506.449 67.7394 506.247 67.6786L506.244 67.6777L503.244 66.7265C502.907 66.6185 502.58 66.4832 502.266 66.3212L502.263 66.3203C501.941 66.1485 501.653 65.9359 501.399 65.6835L501.397 65.6826C501.139 65.4193 500.935 65.1067 500.784 64.748V64.747C500.631 64.3748 500.557 63.9437 500.557 63.4589C500.557 62.6817 500.745 62.0068 501.131 61.4453C501.518 60.8847 502.04 60.458 502.691 60.165C503.342 59.8726 504.071 59.7312 504.875 59.7372Z"
            fill="white"
            stroke="white"
            strokeWidth={0.392424}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M505.789 57.3168C506.006 57.3168 506.182 57.4925 506.182 57.7093V61.2411H503.565V57.7093C503.565 57.4925 503.741 57.3168 503.958 57.3168H505.789Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M506.182 71.706V75.2378C506.182 75.4545 506.006 75.6302 505.789 75.6302H503.958C503.741 75.6302 503.565 75.4545 503.565 75.2378V71.706H506.182Z"
            fill="white"
          />
        </g>
      </g>
    </g>

    <defs>
      <linearGradient
        id="paint0_linear_1695_3152"
        x1={294.333}
        y1={190.159}
        x2={294.333}
        y2={285.714}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#EAEAEA"
          stopOpacity={1}
        />
        <stop
          offset={1}
          stopColor="#EAEAEA"
          stopOpacity={0}
        />
      </linearGradient>

      <clipPath id="clip0_1695_3152">
        <rect
          width={590}
          height={316}
          fill="white"
        />
      </clipPath>

      <clipPath id="clip1_1695_3152">
        <rect
          width={434.455}
          height={263.131}
          fill="white"
          transform="translate(83.6729 53.2206)"
        />
      </clipPath>

      <clipPath id="clip2_1695_3152">
        <rect
          x={492.104}
          y={53.2202}
          width={26.0239}
          height={26.0239}
          rx={13.012}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default MonetizationCardSvg;